module.exports = __webpack_public_path__ + "static/media/icons8-high priority red.a0ae302d.svg";